import header from "./unterlagen-durchgehen.jpg";
import section1 from "./schluessel-uebergabe.webp";
import section2 from "./unterlagen-fur-eine-baufinanzierung-bank-plans.jpg";
import section3 from "./baufinanzierung-selbststaendige.webp";
import section4 from "./abschluss-baufinanzierung.webp";
import section5 from "./baufinanzierung-wird-unterzeichnet.jpg";
import section6 from "./wichtige-dokumente.webp";
import section7 from "./unterlagen-fur-eine-baufinanzierung-living-space-table.jpg";

export {
  header,
  section1,
  section2,
  section3,
  section4,
  section5,
  section6,
  section7,
};
